import { createSlice } from "@reduxjs/toolkit";
import apiManagerUser from "api/manager-users";
import { setShowBackdrop } from "store/commonSlice";
import store from "store/store";

export const fetchData = async (data) => {
    try {
        store.dispatch(setShowBackdrop(true))
        const res = await apiManagerUser.getListUser(data);
        if (res.status === 200) {
            store.dispatch(setTableData({
                data: res.data,
                total: res.total
            }))
        } else console.log("info: ", res);
    } catch (err) {
        console.log("err: ", err)
    } finally {
        store.dispatch(setIsLoading(false))
        store.dispatch(setShowBackdrop(false))
    }
}

const initialState = {
    tableData: {
        data: [],
        total: 0
    },
    searchQuery: {
        status: ['isactive', 'locked'],
        role: ['admin','sip','guest'],
        userType: ['PUBLIC', 'ORG'],
        username: '',
        name: '',
        unitId: '',
        page: 0
    },
    isRefresh: false,
    isLoading: false,
}

export const managerUserSlice = createSlice({
    name: 'manageruser',
    initialState,
    reducers: {
        setTableData: (state, action) => void (state.tableData = action.payload),
        setSearchQuery: (state, action) => void (state.searchQuery = action.payload),
        toggleIsRefresh: (state) => void (state.isRefresh = !state.isRefresh),
        setIsLoading: (state, action) => void (state.isLoading = action.payload),
        setDefaultSearchQuery: (state, action) => void (
            state.searchQuery.status = ['isactive', 'locked'],
            state.searchQuery.role = ['admin','sip','guest'],
            state.searchQuery.userType = ['PUBLIC', 'ORG'],
            state.searchQuery.username = '',
            state.searchQuery.name = '',
            state.searchQuery.unitId = '',
            state.searchQuery.page = 0
        )
    }
})

export const { setTableData, setSearchQuery, toggleIsRefresh, setIsLoading, setDefaultSearchQuery } = managerUserSlice.actions
export default managerUserSlice.reducer
